import { useTranslation } from 'react-i18next';
import { resolveApiErrorMessage } from '@/api/resolveApiErrorMessage';
import { showErrorNotification, showSuccessNotification } from '@/utils/notifications';

export function useConfigurationSaveNotifications() {
  const { t } = useTranslation('assistant');
  return {
    onSuccess: function notifySaved() {
      showSuccessNotification(t('configuration.saved'));
    },
    onError: function notifyError(saveError: unknown) {
      const backendMessage = resolveApiErrorMessage(saveError);
      showErrorNotification(
        backendMessage.length > 0 ? backendMessage : t('configuration.saveError')
      );
    },
  };
}
